export default __webpack_public_path__ + "static/media/round.44cd968d.png";